import React from "react";

function InputField({ input, setInput }) {
  return (
    <input
      id="task"
      autoComplete="off"
      placeholder="What's on your plate?"
      value={input}
      onChange={(event) => {
        setInput(event.target.value);
      }}
      className="focus:shadow-outline w-full appearance-none rounded-xl border p-3 leading-tight text-gray-700 shadow outline-none focus:outline-none dark:border-none dark:bg-zinc-900 dark:text-white dark:placeholder:text-zinc-500 dark:focus:outline-zinc-700"
    />
  );
}

export default InputField;
